import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import clsx from 'clsx';

export type Props = {
  filters: { label: ReactNode; value: ReactNode }[];
  label?: string;
  className?: string;
};

/**
 * A generic component for displaying a summary of applied filters
 *
 * - nothing rendered if all values are empty
 * - sub block not rendered if no value
 */
export default function FilterSummary({ filters, label, className }: Props): ReactElement | null {
  if (!filters.filter((f) => f.value).length) {
    return null;
  }

  return (
    <section className={clsx(className, 'px-3 py-2 alert-warning')}>
      <div className="fw-bold me-3">{label || 'Applied Filters'}:</div>
      <div className="d-flex">
        {filters
          .filter((f) => f.value)
          .map((filter) => (
            <div
              key={`filter-summary-${filter.label}`}
              className="px-2 me-2"
              style={{ borderStyle: 'dashed', borderWidth: '1px' }}
            >
              {filter.label}: {filter.value}
            </div>
          ))}
      </div>
    </section>
  );
}
